export default __webpack_public_path__ + "static/media/draft.64590276.png";